import { ProductListView } from '@today/ui-domain'
import { useProductList } from '@/hooks/products/useProductList'

/** `/products` — the product list (TO-416 product-admin-ui REQ-002). */
export function ProductsListPage() {
	return <ProductListView {...useProductList()} />
}
